export function initializeSelectMenus() {

	const mvtInputWraps = document.querySelectorAll( '[data-hook~="mvt-input"]' );
	const mvtSelectWraps = document.querySelectorAll( '[data-hook~="mvt-select"]' );

	for ( let element of mvtInputWraps ) {

		let classes = element.getAttribute( 'data-classlist' );
		let id = element.getAttribute( 'data-id' );
		let mvtInputs = element.querySelectorAll( 'input' );

		for ( let mvtInput of mvtInputs ) {

			if ( mvtInput.getAttribute( 'type' ) !== 'hidden' ) {

				mvtInput.setAttribute( 'class', classes );
				mvtInput.setAttribute( 'id', id );
				
			}

		}

	}

	for ( let element of mvtSelectWraps ) {

		let classes = element.getAttribute( 'data-classlist' );
		let id = element.getAttribute( 'data-id' );
		let mvtSelects = element.querySelectorAll( 'select' );

		for ( let mvtSelect of mvtSelects ) {
			
			mvtSelect.setAttribute( 'class', classes );
			mvtSelect.setAttribute( 'id', id );
			
		}

	}

}